<page-title [title]="title"></page-title>
<p>Consulte e gerencie suas configurações:</p>

<page-alert
  message="Configurações salvas com sucesso!"
  *ngIf="submittedPaymentSettings && sucessPaymentSettings"
  alertClass="alert-success"
></page-alert>
<page-alert message="Falha ao salvar configurações" *ngIf="submittedPaymentSettings && !sucessPaymentSettings" alertClass="alert-danger"></page-alert>

<mat-tab-group>
  <mat-tab label="Formas de Pagamento">
    <form [formGroup]="paymentForm">
      <page-title title="Formas de Pagamento"></page-title>
      <br />
      <div class="col-xs-12">
        <mat-card class="payment-card">
          <mat-checkbox class="large-checkbox" formControlName="PIXActive"></mat-checkbox>
          <span class="payment-text">PIX</span>
        </mat-card>
      </div>
      <div class="col-xs-12">
        <mat-card class="payment-card">
          <mat-checkbox class="large-checkbox" formControlName="CreditCardActive"></mat-checkbox>
          <div class="payment-info">
            <span class="payment-text">Cartão de Crédito</span>
          </div>
        </mat-card>
      </div>

      <div class="col-xs-12">
        <mat-form-field appearance="outline" class="form-field">
          <input matInput formControlName="secretary_commission_percentage" type="number" min="0" max="99" placeholder="Ex: 10" />
          <mat-error *ngIf="paymentForm.get('secretary_commission_percentage')?.hasError('required')">
            O percentual de comissão é obrigatório
          </mat-error>
          <mat-error *ngIf="paymentForm.get('secretary_commission_percentage')?.hasError('min')"> O percentual deve ser no mínimo 0 </mat-error>
          <mat-error *ngIf="paymentForm.get('secretary_commission_percentage')?.hasError('max')"> O percentual deve ser no máximo 99 </mat-error>
          <mat-error *ngIf="paymentForm.get('secretary_commission_percentage')?.hasError('pattern')"> Informe um número inteiro </mat-error>
        </mat-form-field>
        <p>Percentual principal: {{ mainPercentage }}%</p>
      </div>

      <div class="actions" align="end">
        <button mat-raised-button color="primary" (click)="createOrUpdateSettings()" type="submit">Salvar</button>
      </div>
    </form>
  </mat-tab>

  <mat-tab label="Dados Bancários">
    <page-title title="Informe seus dados bancários"></page-title>

    <div class="bank-details-container">
      <mat-card>
        <form [formGroup]="bankDetailsForm">
          <div class="row">
            <div class="col-xs-12 col-sm-6">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Nome do Banco</mat-label>
                <input matInput formControlName="bank_name" placeholder="Ex: Banco do Brasil" />
                <mat-error *ngIf="bankDetailsForm.get('bank_name')?.hasError('required')"> O nome do banco é obrigatório </mat-error>
              </mat-form-field>
            </div>
            <div class="col-xs-12 col-sm-6">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Agência</mat-label>
                <input matInput formControlName="agency_number" placeholder="" mask="0000" placeholder="Digite os 4 números da agência" />
                <mat-error *ngIf="bankDetailsForm.get('agency_number')?.hasError('required')"> O número da agência é obrigatório </mat-error>
              </mat-form-field>
            </div>

            <div class="col-xs-12 col-sm-6">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Número da Conta</mat-label>
                <input matInput formControlName="account_number" maxlength="13" placeholder="Conta (de 5 a 11 dígitos + DV, ex: 123456-7)" />
                <mat-error *ngIf="accountNumber?.invalid && (accountNumber?.touched || accountNumber?.dirty)">
                  <ng-container *ngIf="accountNumber?.hasError('required')"> O número da conta é obrigatório. </ng-container>
                  <ng-container *ngIf="accountNumber?.hasError('pattern')">
                    Formato inválido. Use de 5 a 11 números seguidos de hífen(-) e 1 dígito verificador. Ex: 123456-7
                  </ng-container>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-xs-12 col-sm-6">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Tipo de Conta</mat-label>
                <mat-select formControlName="account_type">
                  <mat-option value="corrente">Corrente</mat-option>
                  <mat-option value="poupanca">Poupança</mat-option>
                </mat-select>
                <mat-error *ngIf="bankDetailsForm.get('account_type')?.hasError('required')"> O tipo de conta é obrigatório </mat-error>
              </mat-form-field>
            </div>
          </div>
        </form>
      </mat-card>
      <div class="actions" align="end">
        <button mat-raised-button color="primary" type="submit" [disabled]="bankDetailsForm.invalid" (click)="createOrUpdateSettings()">
          Enviar
        </button>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
